/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Table.module.css';

const Table = props => {
  const { station, onClickAddSensor } = props;
  const { name, revenueCenterName } = station || {};
  return (
    <div className={styles.container}>
      <span className={styles.addIcon} onClick={() => onClickAddSensor(station)}>+</span>
      <div className={styles.tableNum}>{name} {revenueCenterName && (
        <div className={styles.tableNum} style={{ fontSize: '2vh' }}>
          ({revenueCenterName})
        </div>
      )}</div>      
    </div>
  );
};

export default Table;

Table.propTypes = {
  station: PropTypes.object,
  onClickAddSensor: PropTypes.func,
};

Table.defaultProps = {
  station: {},
  onClickAddSensor: () => {},
};
